const FORM_SUBMISSION_CRITICAL_ERROR_MSG_COUNTRY_MAP = {
    sg: 'There was a problem with the form submission. Please try again.',
    c2: '表单提交时出现问题。请再试一次。',
    jp: 'フォームの送信に問題がありました。もう一度試してください。'
};

const getFormSusbmissionErrorObj = ({ country }) => ({
    errorMessage:
        FORM_SUBMISSION_CRITICAL_ERROR_MSG_COUNTRY_MAP[country.toLowerCase()] || '',
});

export { getFormSusbmissionErrorObj };
